import React from 'react';
import { BrowserRouter as Router } from 'react-router';
import { Provider } from 'jotai';

import { HydrateInitialAtoms } from '../shared/components/hydrate-initial-atoms';

import { RouteSwitch } from './routes';

import './style.css';

export const Root = () => {
    const { moneyPoolInitial, appConfig } = window;

    return (
        <Provider>
            <HydrateInitialAtoms
                platform='desktop'
                appConfig={appConfig}
                moneyPoolInitial={moneyPoolInitial}
            />
            <Router>
                <RouteSwitch />
            </Router>
        </Provider>
    );
};
